import { getEnvVar } from '@/utils/env';

export const BASE_URL = getEnvVar('VITE_BASE_URL');
export const ADMIN_URL = getEnvVar('VITE_ADMIN_URL');
export const AIR_URL = getEnvVar('VITE_AIR_URL');
export const CRUISE_URL = getEnvVar('VITE_CRUISE_URL');
export const HOTEL_URL = getEnvVar('VITE_HOTEL_URL');
export const PACKAGE_URL = getEnvVar('VITE_PACKAGE_URL');
export const NOTIFICATION_URL = getEnvVar('VITE_NOTIFICATION_URL');
export const REMINDER_URL = getEnvVar('VITE_REMINDER_URL');
export const PROMOS_URL = getEnvVar('VITE_PROMOS_URL');
export const MDT_URL = getEnvVar('VITE_MDT_URL');
export const QUOTE_LOG_URL = getEnvVar('VITE_QUOTE_LOG_URL');
